import { Box } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import { useEffect, useState } from 'react'
import { COLORS } from '../styles/colors'
import { TypographyPrimary } from './typography/TypographyPrimary'

const CustomPagination = props => {
	const {
		initialArray,
		setVisibleState,
		count,
		onChangeFromServer,
		isResetPage = false,
		totalCount,
		page, // опциональный проп для контролируемого режима
	} = props
	const [internalPage, setInternalPage] = useState(1)

	// Если передан page - контролируемый режим, иначе - неконтролируемый
	const isControlled = page !== undefined
	const currentPage = isControlled ? page : internalPage

	const itemsPerPage = count

	const rows = Array.isArray(initialArray) ? initialArray : []
	const totalItems = totalCount ? totalCount : rows.length
	const pageCount = Math.ceil(totalItems / itemsPerPage)
	const hasRows = totalItems > 0

	const handleChange = (event, value) => {
		// В неконтролируемом режиме обновляем внутренний state
		if (!isControlled) {
			setInternalPage(value)
		}
		// В контролируемом режиме просто вызываем callback
		if (isControlled && onChangeFromServer) {
			onChangeFromServer(value)
		}
	}

	// В неконтролируемом режиме вызываем callback при изменении страницы
	useEffect(() => {
		if (!isControlled && onChangeFromServer) {
			onChangeFromServer(currentPage)
		}
	}, [currentPage, onChangeFromServer, isControlled])

	// Сброс страницы работает только в неконтролируемом режиме
	useEffect(() => {
		if (!isControlled && isResetPage) {
			setInternalPage(1)
		}
	}, [isResetPage, isControlled])

	// Сброс на первую страницу при изменении данных (только в неконтролируемом режиме)
	useEffect(() => {
		if (!isControlled && initialArray) {
			setInternalPage(1)
		}
	}, [initialArray, isControlled])

	const startIndex = (currentPage - 1) * itemsPerPage
	const endIndex = Math.min(currentPage * itemsPerPage, totalItems)

	useEffect(() => {
		if (!Array.isArray(initialArray)) return
		const visibleItems = initialArray.slice(startIndex, endIndex)
		setVisibleState(visibleItems)
	}, [initialArray, currentPage, startIndex, endIndex])

	return (
		<>
			{hasRows && (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<Box>
						<TypographyPrimary>
							<span style={{ fontWeight: '600' }}>{`${
								startIndex + 1
							} - ${endIndex}`}</span>{' '}
							из <span style={{ fontWeight: '600' }}>{totalItems}</span>
						</TypographyPrimary>
					</Box>
					<Pagination
						count={pageCount}
						page={currentPage}
						onChange={handleChange}
						shape='rounded'
						color='primary'
						size='small'
						boundaryCount={1}
						sx={{
							'& .MuiPaginationItem-root': {
								fontSize: '14px',
								width: 20,
								height: 20,
								minWidth: 20,
								margin: '0 2px',
								padding: 0,
							},
							'& .Mui-selected': {
								fontWeight: '600',
								backgroundColor: '#EEE9FA !important',
								color: `${COLORS.main} !important`,
								'&:hover': {
									backgroundColor: '#EEE9FA !important',
								},
							},
						}}
					/>
				</Box>
			)}
		</>
	)
}

export default CustomPagination
